import { Box } from "@mui/material";
import type { PaymentActionsProps } from "Components/Dashboard/BalanceWithPaymentActions/types";
import { ButtonLink } from "Components/Shared/ButtonLink";
import { ForwardArrowIcon, PlusMathIcon } from "Components/Shared/Icons";

export const PaymentActions = ({
  payMeAction,
  sendPaymentAction,
}: PaymentActionsProps) => (
  <Box display="flex" gap={4} mt={4}>
    <PayMeButton
      link={payMeAction.link}
      text={payMeAction.text}
      disabled={payMeAction.isDisabled}
    />
    <SendPaymentButton
      link={sendPaymentAction.link}
      text={sendPaymentAction.text}
      disabled={sendPaymentAction.isDisabled}
    />
  </Box>
);

type PaymentButtonProps = {
  link: string;
  text: string;
  disabled: boolean;
};

const SendPaymentButton = (props: PaymentButtonProps) => (
  <ButtonLink
    variant="outlined"
    color="info"
    startIcon={<ForwardArrowIcon width={20} height={20} />}
    {...props}
  />
);

const PayMeButton = (props: PaymentButtonProps) => (
  <ButtonLink
    color="primary"
    variant="contained"
    startIcon={<PlusMathIcon width={20} height={20} />}
    {...props}
  />
);
